const tables = [
  {
    name: "Name",
  },
  {
    name: "Number",
  },
  {
    name: "Est.expense",
  },
  {
    name: "Expense",
  },
  {
    name: "Progress",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
